import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Square, SquareCheck } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table';
/**
 * A very simple generic table component to render out static tables.
 *
 * Simply pass an array of objects into its `data` prop.
 * All objects **MUST** have the same keys
 *  and they must all be in the same order
 */
export const JSONTable = ({ data, excludeKeys = [] }) => {
    const headerKeys = Object.keys(data?.[0] ?? {});
    return (_jsxs(Table, { children: [_jsx(TableHeader, { children: _jsx(TableRow, { children: headerKeys.map((key) => !excludeKeys.includes(key) && (_jsx(TableHead, { className: 'whitespace-nowrap', children: key }, key))) }) }), _jsx(TableBody, { children: data.map((row, index) => {
                    const entries = Object.entries(row ?? {});
                    return (_jsx(TableRow, { children: entries.map(([key, value]) => {
                            return (!excludeKeys.includes(key) && (_jsx(TableCell, { children: renderContent(value) }, key)));
                        }) }, index));
                }) })] }));
};
/**
 * Render the value of an object
 *
 * This may need to be frequently updated as we use this component more often
 */
const renderContent = (value) => {
    if (typeof value === 'boolean') {
        return value ? (_jsx(SquareCheck, { size: 20, strokeWidth: 1.5, className: 'text-green-700' })) : (_jsx(Square, { size: 20, strokeWidth: 1.5 }));
    }
    return value;
};
